const mainHeadersActions = document.querySelectorAll<HTMLElement>('.main-header-actions')

const mobileQuery = window.matchMedia("(max-width: 61.999em)")
mainHeadersActions.forEach(actionHeader => {
  const cartButton = actionHeader.querySelector<HTMLElement>('.main-header-actions__cart-button');

  cartButton?.addEventListener('click', (e) => {
    if (!mobileQuery.matches) return;
    const targetElement = e.target as HTMLElement

    if (!cartButton.querySelector(".main-header-cart__panel")) return

    if (targetElement.closest(".main-header-cart__panel")) return
    e.preventDefault()
    const panel = actionHeader.querySelector<HTMLElement>('.main-header-actions__cart-panel');
    panel?.classList.add('--open');
  })
})
